var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelaxation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 318,
    viewBox: "0 0 318 318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_380",
    x: 0,
    y: 0,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_16_5",
    "data-name": "Component 16 \\u2013 5",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_380)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380-2",
    "data-name": "Rectangle 380",
    width: 300,
    height: 300,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Relaxation",
    transform: "translate(150 279.1)",
    fill: "#099",
    fontSize: 48,
    fontFamily: "MyriadPro-Semibold, Myriad Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -110.208,
    y: 0
  }, "Relaxation")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(50 25.1)",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_50",
    "data-name": "Union 50",
    d: "M-1211.152,8445.762a2.228,2.228,0,0,1-1.6-2.711l17.439-67.477a26.618,26.618,0,0,0-17.318,2.223l-2.094,1.189-1.006-2.225a13.559,13.559,0,0,0-9.531-7.719,13.465,13.465,0,0,0-5.107-.133l-2.241.367-.323-2.25a7,7,0,0,1,.088-2.471c1.729-7.949,7.443-14.545,16.083-18.559,8.625-4.008,19.123-4.963,29.552-2.689,10.449,2.273,19.608,7.508,25.793,14.734,6.2,7.246,8.657,15.617,6.925,23.566a6.956,6.956,0,0,1-.945,2.281l-1.225,1.91-1.886-1.264a13.522,13.522,0,0,0-4.7-2,13.57,13.57,0,0,0-11.875,3.057l-1.847,1.609-1.417-1.979a25.394,25.394,0,0,0-12.615-8.553l-17.445,67.494a2.228,2.228,0,0,1-2.153,1.67A2.188,2.188,0,0,1-1211.152,8445.762Zm48.857-67.572a17.9,17.9,0,0,1,3.694,1.232c1.668-11.2-6.83-23-20.833-29a34.068,34.068,0,0,1,6.605,19.2,48.617,48.617,0,0,1-.5,9.652,18.411,18.411,0,0,1,7.221-1.486A17.929,17.929,0,0,1-1162.3,8378.189Zm-38.818-7.609a36.673,36.673,0,0,1,7.814.857,32.405,32.405,0,0,1,15.478,7.773,44.769,44.769,0,0,0,.541-9.473c-.511-9.414-4.176-16.771-10.885-21.875-8.231,1.852-14.621,7.021-19,15.369a44.438,44.438,0,0,0-3.436,8.82,28.6,28.6,0,0,1,8.986-1.479C-1201.449,8370.574-1201.283,8370.576-1201.114,8370.58Zm-27.067-6.307h.029a17.985,17.985,0,0,1,3.84.416,18.34,18.34,0,0,1,9.583,5.572,48.7,48.7,0,0,1,3.573-9,34.027,34.027,0,0,1,13.983-14.7c-.381-.006-.762-.012-1.14-.012C-1213.032,8346.547-1225.119,8353.656-1228.181,8364.273Zm130.8,79.883-5.456-21.113H-1148V8443.6a2.228,2.228,0,0,1-2.225,2.225,2.23,2.23,0,0,1-2.225-2.225v-12.3l-3.107,11.182a4.6,4.6,0,0,1-4.4,3.338h-40.7a4.557,4.557,0,0,1-3.635-1.795,4.548,4.548,0,0,1-.762-3.986l5.029-18.1a4.6,4.6,0,0,1,4.4-3.342h47.766a4.644,4.644,0,0,1,.166-1.34l5.032-18.1a4.6,4.6,0,0,1,4.4-3.342h40.7a4.556,4.556,0,0,1,3.632,1.795,4.558,4.558,0,0,1,.762,3.99l-5.029,18.1a4.509,4.509,0,0,1-.58,1.264l5.706,22.072a2.231,2.231,0,0,1-1.593,2.715,2.226,2.226,0,0,1-.56.072A2.227,2.227,0,0,1-1097.378,8444.156Zm-103.4-2.939a.1.1,0,0,0,.016.1.112.112,0,0,0,.091.049h40.737a.117.117,0,0,0,.078-.088l.837-3.016h-40.939Zm2.058-7.4h40.939l.9-3.24h-40.942Zm2.974-10.7-.837,3.018h40.942l.818-2.955a.105.105,0,0,0-.016-.1.121.121,0,0,0-.088-.047h-40.708A.122.122,0,0,0-1195.746,8423.123Zm52.326-4.689a.109.109,0,0,0,.016.1.119.119,0,0,0,.075.053l40.72-.006a.117.117,0,0,0,.114-.086l.837-3.01H-1142.6Zm2.068-7.387h40.939l.9-3.236h-40.942Zm3.084-10.787a.114.114,0,0,0-.111.088l-.837,3.016h40.942l.817-2.951a.1.1,0,0,0-.016-.1.258.258,0,0,0-.13-.057Z",
    transform: "translate(1313 -8268.869)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxation);
export default __webpack_public_path__ + "static/media/relaxation.3c1d870ff2d5043143e14336550a4e12.svg";
export { ForwardRef as ReactComponent };